// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SriLanka from '../_raw/flag/icon_flag_sri_lanka.png';

export default () => <img src={SriLanka} alt="SriLanka" />;
